import { useEffect, useRef } from 'react'
import { Chart, registerables } from 'chart.js'
import { palette } from '@versports/theme'
import { baseChartOptions } from '../../components/chartTheme'
import type { AdminActivityDay } from '../../api/admin'
import { dayLabel, SESSION_STATES } from './sessionOverview'

Chart.register(...registerables)

export const ACTIVITY_COLORS = {
  closed: palette.primary, running: palette.secondary, pending: palette.warning,
  aborted: palette.danger, other: palette.textMuted,
}

export function SessionActivityChart({ days }: { days: AdminActivityDay[] }) {
  const canvas = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    if (!canvas.current) return
    const base = baseChartOptions()
    const chart = new Chart(canvas.current, {
      type: 'bar',
      data: {
        labels: days.map(d => dayLabel(d.day)),
        datasets: SESSION_STATES.map(s => ({
          label: s.label, data: days.map(d => d[s.key]), backgroundColor: ACTIVITY_COLORS[s.key],
          borderRadius: 3, maxBarThickness: 32, borderSkipped: false,
        })),
      },
      options: {
        ...base, animation: false,
        interaction: { mode: 'index', intersect: false },
        plugins: { ...base.plugins, legend: { display: false }, tooltip: {
          ...base.plugins?.tooltip,
          filter: item => Number(item.raw) > 0,
          callbacks: { footer: items => `${items.reduce((n, i) => n + Number(i.raw), 0)} sesiones` },
        } },
        scales: {
          x: { ...base.scales?.x, stacked: true, grid: { display: false }, ticks: { color: palette.textMuted, maxRotation: 0, autoSkip: true } },
          y: { ...base.scales?.y, stacked: true, beginAtZero: true, ticks: { color: palette.textMuted, precision: 0 }, suggestedMax: 4 },
        },
      },
    })
    return () => chart.destroy()
  }, [days])
  return <div className="h-64 sm:h-72"><canvas ref={canvas} role="img" aria-label="Sesiones por día y estado durante los últimos 14 días. Las cifras están disponibles debajo del gráfico." /></div>
}
